import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import * as echarts from 'echarts'


import ajax from './assets/js/axios.config';
import utils from './assets/js/utils';
import tool from './assets/js/tool';





import './assets/css/reset.css'
import './assets/scss/icon.scss'
import './assets/scss/main.scss'
import './assets/js/fontSize.js'
import './assets/js/numberToCurrency.js'






import 'element-ui/lib/theme-chalk/index.css';


Vue.prototype.$echarts=echarts

Vue.config.productionTip = false;

Vue.prototype.$ajax = ajax
Vue.prototype.$utils = utils;


Vue.use(ElementUI);
Vue.use(tool);


new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
